import type { ICurrentWindowStore } from "./ICurrentWindowStore";
import { computed, makeObservable } from "mobx";
import { type ILocalStorage, WindowLocalStorage } from "../../util/io/LocalStorage";

export class DefaultCurrentWindowStore implements ICurrentWindowStore {
	constructor() {
		makeObservable(this);
	}

	@computed
	public get currentWindow(): Window {
		return window;
	}

	@computed
	public get localStorage(): ILocalStorage {
		return new WindowLocalStorage(this.currentWindow);
	}

	@computed
	public get devicePixelRatio() {
		return this.currentWindow.devicePixelRatio || 1;
	}
}
